var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-theme-provider',[_c('Loader'),_c('LoaderOpacity'),_c('LoarderCheck'),_c('ModalSaveSucess'),_c('ModalSendSucess'),_c('c-reset'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }